var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvocate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 128,
    viewBox: "0 0 193 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A4CCEC",
    fillRule: "nonzero",
    d: "M181.578 67.34c-1.234 2.923-2.269 6.032-1.88 9.145.725 5.752 5.627 9.115 8.861 13.62 3.223 4.481 4.762 9.802 4.385 15.155-.804 10.347-8.959 18.214-18.662 22.74H14.134c-9.066-5.35-15.488-14.83-13.89-22.236 2.634-12.212 13.4-16.92 14.19-27.54.66-8.757-4.306-17.428.245-25.85 3.266-6.048 9.44-10.113 16.467-11.89 8.372-2.114 40.14-5.68 58.852-5.68 18.713 0 25.782-6.525 47.821-9.98 16.17-2.534 27.861.768 37.01 9.98 9.42 9.486 10.94 22.613 6.749 32.536z",
    opacity: 0.936
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54) rotate(19 25.383 155.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.552,
    height: 102.127,
    fill: "#D6EBFF",
    rx: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 22.418,
    fill: "#2585C2",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 28.484,
    fill: "#2585C2",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 34.549,
    fill: "#2585C2",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 40.614,
    fill: "#2585C2",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 59.781,
    fill: "#2585C2",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 65.847,
    fill: "#2585C2",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 82.199,
    fill: "#2585C2",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 88.265,
    fill: "#2585C2",
    rx: 1.011
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54) translate(22.22 7.699)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.862,
    height: 102.319,
    fill: "#EBF5FF",
    rx: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.677,
    height: 2.026,
    x: 7.592,
    y: 22.46,
    fill: "#2585C2",
    opacity: 0.46,
    rx: 1.013
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.677,
    height: 2.026,
    x: 7.592,
    y: 28.537,
    fill: "#2585C2",
    opacity: 0.46,
    rx: 1.013
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.677,
    height: 2.026,
    x: 7.592,
    y: 34.614,
    fill: "#2585C2",
    opacity: 0.46,
    rx: 1.013
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.677,
    height: 2.026,
    x: 7.592,
    y: 40.691,
    fill: "#2585C2",
    opacity: 0.46,
    rx: 1.013
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.677,
    height: 2.026,
    x: 7.592,
    y: 59.894,
    fill: "#2585C2",
    opacity: 0.46,
    rx: 1.013
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.677,
    height: 2.026,
    x: 7.592,
    y: 65.971,
    fill: "#2585C2",
    opacity: 0.46,
    rx: 1.013
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.677,
    height: 2.026,
    x: 7.592,
    y: 82.354,
    fill: "#2585C2",
    opacity: 0.46,
    rx: 1.013
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.677,
    height: 2.026,
    x: 7.592,
    y: 88.431,
    fill: "#2585C2",
    opacity: 0.46,
    rx: 1.013
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54) rotate(-12 77.455 2.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFDFF",
    d: "M6.244 6.928L12.13 0h56.32c1.16 0 2.1.94 2.1 2.1v97.926c0 1.16-.94 2.1-2.1 2.1H2.1c-1.16 0-2.1-.94-2.1-2.1V12.045l5.967-4.846c.1-.082.193-.172.277-.27z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.543,
    height: 2.022,
    x: 7.559,
    y: 20.396,
    fill: "#62A4D0",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.221,
    height: 2.022,
    x: 7.559,
    y: 30.505,
    fill: "#62A4D0",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 36.571,
    fill: "#62A4D0",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.221,
    height: 2.022,
    x: 7.559,
    y: 50.724,
    fill: "#62A4D0",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.221,
    height: 2.022,
    x: 7.559,
    y: 56.789,
    fill: "#62A4D0",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 62.855,
    fill: "#62A4D0",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.559,
    y: 68.92,
    fill: "#62A4D0",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.158,
    y: 82.895,
    fill: "#62A4D0",
    rx: 1.011
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.434,
    height: 2.022,
    x: 7.158,
    y: 88.96,
    fill: "#62A4D0",
    rx: 1.011
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0DA1EC",
    fillOpacity: 0.1,
    d: "M15.607 16.264l-2.052 9.311c-.303 1.38-1.668 2.25-3.047 1.947l-.024-.006-9.442-2.177 14.565-9.075z",
    transform: "translate(54)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0368A5",
    d: "M1.49 87.384c-1.986-2.006-1.986-5.258 0-7.264L32.407 48.89l7.192 7.264-30.922 31.23c-.953.964-2.246 1.506-3.595 1.506-1.348 0-2.641-.542-3.594-1.505z",
    transform: "translate(20 17.103)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0368A5",
    d: "M56.65 0C39.336 0 25.3 13.929 25.3 31.111c0 17.182 14.036 31.111 31.35 31.111S88 48.293 88 31.112C88 13.928 73.964 0 56.65 0zm0 55.113c-9.784.002-18.606-5.847-22.351-14.817-3.745-8.97-1.676-19.297 5.243-26.163 6.919-6.866 17.324-8.92 26.363-5.203 9.04 3.717 14.933 12.471 14.932 22.181 0 6.366-2.547 12.472-7.083 16.974-4.536 4.502-10.689 7.032-17.104 7.032v-.004z",
    transform: "translate(20 17.103)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F96D4",
    d: "M39.79 48.083c-6.156-6.096-8.585-14.77-6.332-23.1 2.253-8.328 9.636-14.746 17.995-17.04 8.36-2.293 17.52.806 22.586 6.204 1.701-1.68 3.527-3.634 5.161-5.398C74.75 4.818 70.345 2.17 64.485.807c-5.68-1.324-11.82-.958-17.4.65-9.876 3.17-17.912 11.47-20.692 21.377-2.897 10.317.08 22.17 7.551 29.943l.548.556 5.298-5.25z",
    transform: "translate(20 17.103)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvocate);
export default __webpack_public_path__ + "static/media/advocate.4fb7143b8757743a48dd316e03433f17.svg";
export { ForwardRef as ReactComponent };